<template>

<!--    <p class="content"><b>Selected:</b> {{ selected }}</p>-->

      <b-autocomplete
        v-model="modelValue"
        icon="magnify"
        :data="data"
        :placeholder="placeholder ? placeholder : 'Location, city, zipcode'"
        field="Address"
        :loading="isFetching"
        @typing="getAsyncData"
        @select="onSelect"
        clearable
        keep-first

      >
        <template #header>
          <a @click="onSelect({'Address': modelValue, type : 'address'})"><span> Search for it... </span></a>
        </template>
        <template #empty>No results found</template>
<!--        <template slot-scope="props">-->
<!--          <div class="media"  v-if="!props.option.type || props.option.type !== 'city'">-->
<!--            <div class="media-left">-->
<!--              <img width="32" :src="props.option.ListPictureURL">-->
<!--            </div>-->
<!--            <div class="media-content">-->
<!--              <p>-->
<!--                {{props.option.FullStreetAddress.toLowerCase()}},-->
<!--              </p>-->
<!--              <p>-->
<!--                <small>-->
<!--                {{props.option.City.toLowerCase()}}-->
<!--                {{props.option.StateOrProvince.toUpperCase()}}-->
<!--                {{props.option.PostalCode.toLowerCase()}}-->
<!--                </small>-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        v-if="props.option.type && props.option.type === 'city'"-->
<!--          <div class="media" >-->
<!--            <div class="media-content">-->
<!--              <p>-->
<!--                {{props.option.UnparsedAddress}}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
      </b-autocomplete>


</template>

<script>
import debounce from 'lodash/debounce'
import {getApiUrl, LISTINGS_SEARCH_API_URL} from "@/Helpers/repository";
//import fetch from "@/he/fetch";

export default {
  name: 'search_input',
  props:{
    value:String,
    placeholder: String
  },
  data() {
    return {
      data: [],
      selected: null,
      isFetching: false,
      address: null
    }
  },
  methods: {
    onSelect(option) {
      if(!option) {
        //option = {'Address' : null};
       // this.$emit('selectItem', option)
      } else {
        this.selected = option;
        this.modelValue = option.Address;
        // if(option.type === 'city') {
        //   console.log('city selected:'+option.SystemId)
        //   this.$emit('selectCity', option.SystemId)
        // } else{
        //   this.$emit('selectProperty', option.SystemUrl)
        //   console.log('selectProperty')
        // }
        //console.log(option.type)
        switch (option.type) {
          case 'city':
            this.$emit('selectCity', option.SystemId)
            break;
          case 'Listing':
            this.$emit('selectListing', option)
            break;
          case 'address':
            this.$emit('selectAddress', option)
            break;
          default:
            this.$emit('selectProperty', option.SystemUrl)
        }
      }
    },
    // You have to install and import debounce to use it,
    // it's not mandatory though.
    getAsyncData: debounce(function (name) {
      if (!name.length) {
        this.data = []
        return
      }
      this.isFetching = true;
      const url = getApiUrl(LISTINGS_SEARCH_API_URL) //"/address/search"
      fetch(url + `?query=${name}`)
        .then((response) => response.json())
        .then((data) => {
          this.data = [];
          const hits = data["items"]
          hits.forEach((item) => this.data.push(item._source))
        })
        .catch((error) => {
          this.data = []
          throw error
        })
        .finally(() => {
          this.isFetching = false
        })
    }, 500)
  },
  emits: ["input"],
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
}
</script>
